<template>
  <div class="ac2" style="width: 100%">
    <!-- banner -->
    <div class="banner">
      <div class="banner-overlay">
        <div class="banner-content">
          <h1>关于我们</h1>
          <p>About Our Company</p>
          <div class="banner-decoration">
            <div class="decoration-line"></div>
            <div class="decoration-dot"></div>
            <div class="decoration-line"></div>
          </div>
        </div>
      </div>
      <img src="/imgs/b3.jpg" alt="" />
    </div>

    <div class="container">
      <!-- 容器 -->
      <div class="a2-con">
        <!-- 公司标题 -->
        <div class="company-header">
          <div class="title-section">
            <h2>京游科技（北京）有限公司</h2>
            <h4>Jingyou Technology (Beijing) Co., Ltd</h4>
            <div class="title-line"></div>
          </div>
          <div class="company-badge">
            <span class="badge-item">科技创新</span>
            <span class="badge-item">专业服务</span>
            <span class="badge-item">诚信经营</span>
          </div>
        </div>

        <!-- 主要内容 -->
        <div class="a2-box">
          <div class="l">
            <!-- 公司简介 -->
            <div class="info-card">
              <div class="card-header">
                <i class="card-icon">🏢</i>
                <h3>公司简介</h3>
              </div>
              <div class="card-content">
                <p>
                  <span class="highlight">
                    京游科技（北京）有限公司</span>
                    成立于2017年04月19日，注册地位于北京市房山区良乡长虹西路翠柳东街1号-4468，我们致力于为企业提供全方位的技术解决方案和数字化服务。
                </p>
              </div>
            </div>

            <!-- 经营范围 -->
            <div class="info-card">
              <div class="card-header">
                <i class="card-icon">🎯</i>
                <h3>经营范围</h3>
              </div>
              <div class="card-content">
                <p>
                 经营范围包括互联网信息服务；从事互联网文化活动；技术开发、技术推广、技术转让、技术咨询、技术服务；计算机系统服务；基础软件服务、应用软件服务；软件开发；软件咨询；产品设计；模型设计；包装装潢设计；教育咨询（中介服务除外）；经济贸易咨询；文化咨询；体育咨询；公共关系服务；会议服务；工艺美术设计；电脑动画设计；企业策划、设计；设计、制作、代理、发布广告；市场调查；企业管理咨询；组织文化艺术交流活动（不含营业性演出）；文艺创作；承办展览展示活动；会议服务；影视策划；翻译服务；自然科学研究与试验发展；工程和技术研究与试验发展；农业科学研究与试验发展；医学研究与试验发展；数据处理（数据处理中的银行卡中心、PUE值在1.5以上的云计算数据中心除外）。（企业依法自主选择经营项目，开展经营活动；依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事本市产业政策禁止和限制类项目的经营活动。）
                </p>
                <div class="business-tags">
                  <span class="business-tag">技术开发</span>
                  <span class="business-tag">软件开发</span>
                  <span class="business-tag">技术服务</span>
                  <span class="business-tag">企业策划</span>
                  <span class="business-tag">互联网文化</span>
                </div>
              </div>
            </div>

            <!-- 核心优势 -->
            <div class="info-card">
              <div class="card-header">
                <i class="card-icon">⭐</i>
                <h3>核心优势</h3>
              </div>
              <div class="card-content">
                <div class="advantage-list">
                  <div class="advantage-item">
                    <i class="advantage-icon">🚀</i>
                    <div class="advantage-text">
                      <h4>技术创新</h4>
                      <p>紧跟技术发展趋势，提供前沿解决方案</p>
                    </div>
                  </div>
                  <div class="advantage-item">
                    <i class="advantage-icon">🤝</i>
                    <div class="advantage-text">
                      <h4>专业服务</h4>
                      <p>资深团队提供专业的技术支持和服务</p>
                    </div>
                  </div>
                  <div class="advantage-item">
                    <i class="advantage-icon">💎</i>
                    <div class="advantage-text">
                      <h4>品质保证</h4>
                      <p>严格的质量控制体系，确保项目交付质量</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="r">
            <div class="image-card">
              <div class="image-container">
                <img src="/imgs/usinfo.jpg" alt="公司形象" />
                <div class="image-overlay">
                  <div class="overlay-content">
                    <i class="overlay-icon">📸</i>
                    <span>公司实景</span>
                  </div>
                </div>
              </div>
              <div class="image-info">
                <h4>企业形象展示</h4>
                <p>专业 · 创新 · 可靠</p>
              </div>
            </div>

            <!-- 联系信息 -->
            <div class="contact-card">
              <div class="contact-header">
                <i class="contact-icon">📞</i>
                <h4>联系我们</h4>
              </div>
              <div class="contact-info">
                <div class="contact-item">
                  <i class="item-icon">📍</i>
                  <span>北京市房山区良乡长虹西路翠柳东街1号-4468</span>
                </div>
                <div class="contact-item">
                  <i class="item-icon">🏢</i>
                  <span>jingyoukeji.cn</span>
                </div>
                <div class="contact-item">
                  <i class="item-icon">🎯</i>
                  <span>网络技术 · 软件开发 · 互联网服务</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";

export default {
  name: "ac1",
  components: {},
  data() {
    return {
      href: "index.html",
      ac1: [],
      ac2: [],
      ac3: [],
      ac: [],
      myData: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init1();
    document.title = "京游科技（北京）有限公司";
  },
  methods: {
    init1() {
      this.axios.get("/mock/index2.json").then((res) => {
        const data = res.data;
        // 咨询区块1
        this.myData = data.splice(0, 3);
      });
    },
    // 跳转功能
    goDays(methodsWords, id) {
      this[methodsWords](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      if (this.state == 0) {
        this.showModal = true;
        console.log(this.showModal);
      }
      // 未登录
      if (this.state !== 0) {
        alert("资讯每条2元，点击确定登录购买");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    msub() {
      this.$message.error("支付失败!");
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac2 {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;

  .banner {
    width: 100%;
    height: 400px;
    position: relative;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s ease;
    }
    
    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(24, 144, 255, 0.8), rgba(82, 196, 26, 0.6));
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      
      .banner-content {
        text-align: center;
        color: #fff;
        
        h1 {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 10px;
          text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        }
        
        p {
          font-size: 18px;
          opacity: 0.9;
          margin-bottom: 20px;
          font-weight: 500;
        }
        
        .banner-decoration {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          
          .decoration-line {
            width: 60px;
            height: 2px;
            background: rgba(255, 255, 255, 0.6);
          }
          
          .decoration-dot {
            width: 8px;
            height: 8px;
            background: #fff;
            border-radius: 50%;
            animation: pulse 2s infinite;
          }
        }
      }
    }
    
    &:hover img {
      transform: scale(1.05);
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 60px 20px;

    // 容器
    .a2-con {
      // 公司标题
      .company-header {
        text-align: center;
        margin-bottom: 50px;
        
        .title-section {
          h2 {
            font-size: 36px;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 10px;
            background: linear-gradient(135deg, #1890ff, #52c41a);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          h4 {
            font-size: 18px;
            color: #666;
            font-weight: 500;
            margin-bottom: 20px;
            letter-spacing: 1px;
          }
          
          .title-line {
            width: 100px;
            height: 3px;
            background: linear-gradient(90deg, #1890ff, #52c41a);
            margin: 0 auto;
            border-radius: 2px;
          }
        }
        
        .company-badge {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin-top: 25px;
          
          .badge-item {
            padding: 8px 20px;
            background: linear-gradient(135deg, #1890ff, #52c41a);
            color: #fff;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 600;
            box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
          }
        }
      }

      .a2-box {
        display: grid;
        grid-template-columns: 1fr 400px;
        gap: 40px;
        align-items: start;

        .l {
          display: flex;
          flex-direction: column;
          gap: 30px;
          
          .info-card {
            background: #fff;
            border-radius: 16px;
            padding: 30px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0, 0, 0, 0.05);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            
            &:hover {
              transform: translateY(-8px);
              box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
            }
            
            .card-header {
              display: flex;
              align-items: center;
              gap: 12px;
              margin-bottom: 20px;
              padding-bottom: 15px;
              border-bottom: 2px solid #f0f0f0;
              
              .card-icon {
                font-size: 24px;
                background: linear-gradient(135deg, #1890ff, #52c41a);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              
              h3 {
                font-size: 22px;
                font-weight: 700;
                color: #1a1a1a;
                margin: 0;
              }
            }
            
            .card-content {
              p {
                font-size: 15px;
                line-height: 1.8;
                color: #595959;
                margin-bottom: 20px;
                
                .highlight {
                  color: #1890ff;
                  font-weight: 600;
                }
              }
              
              .business-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
                margin-top: 20px;
                
                .business-tag {
                  padding: 6px 16px;
                  background: rgba(24, 144, 255, 0.1);
                  color: #1890ff;
                  border-radius: 20px;
                  font-size: 13px;
                  font-weight: 500;
                  border: 1px solid rgba(24, 144, 255, 0.2);
                }
              }
              
              .advantage-list {
                display: flex;
                flex-direction: column;
                gap: 20px;
                
                .advantage-item {
                  display: flex;
                  align-items: flex-start;
                  gap: 15px;
                  padding: 15px;
                  border-radius: 12px;
                  transition: all 0.3s ease;
                  
                  &:hover {
                    background: rgba(24, 144, 255, 0.05);
                  }
                  
                  .advantage-icon {
                    font-size: 20px;
                    margin-top: 2px;
                  }
                  
                  .advantage-text {
                    h4 {
                      font-size: 16px;
                      font-weight: 600;
                      color: #1a1a1a;
                      margin: 0 0 5px 0;
                    }
                    
                    p {
                      font-size: 14px;
                      color: #666;
                      margin: 0;
                      line-height: 1.6;
                    }
                  }
                }
              }
            }
          }
        }

        .r {
          display: flex;
          flex-direction: column;
          gap: 30px;
          position: sticky;
          top: 100px;
          
          .image-card {
            background: #fff;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
            
            .image-container {
              position: relative;
              overflow: hidden;
              
              img {
                width: 100%;
                height: 250px;
                object-fit: cover;
                transition: transform 0.6s ease;
              }
              
              .image-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.7);
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0;
                transition: opacity 0.3s ease;
                
                .overlay-content {
                  color: #fff;
                  text-align: center;
                  
                  .overlay-icon {
                    font-size: 32px;
                    display: block;
                    margin-bottom: 8px;
                  }
                  
                  span {
                    font-size: 14px;
                    font-weight: 600;
                  }
                }
              }
              
              &:hover {
                img {
                  transform: scale(1.1);
                }
                
                .image-overlay {
                  opacity: 1;
                }
              }
            }
            
            .image-info {
              padding: 20px;
              text-align: center;
              
              h4 {
                font-size: 18px;
                font-weight: 600;
                color: #1a1a1a;
                margin: 0 0 5px 0;
              }
              
              p {
                font-size: 14px;
                color: #666;
                margin: 0;
              }
            }
          }
          
          .contact-card {
            background: linear-gradient(135deg, #1890ff, #52c41a);
            border-radius: 16px;
            padding: 30px;
            color: #fff;
            box-shadow: 0 8px 32px rgba(24, 144, 255, 0.3);
            
            .contact-header {
              display: flex;
              align-items: center;
              gap: 12px;
              margin-bottom: 20px;
              
              .contact-icon {
                font-size: 24px;
              }
              
              h4 {
                font-size: 20px;
                font-weight: 600;
                margin: 0;
              }
            }
            
            .contact-info {
              display: flex;
              flex-direction: column;
              gap: 15px;
              
              .contact-item {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                font-size: 14px;
                line-height: 1.5;
                
                .item-icon {
                  font-size: 16px;
                  margin-top: 2px;
                  opacity: 0.9;
                }
                
                span {
                  flex: 1;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 脉冲动画
@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
}

// 入场动画
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.a2-con {
  animation: fadeInUp 0.6s ease forwards;
}

.info-card,
.image-card,
.contact-card {
  animation: fadeInUp 0.6s ease forwards;
}

.info-card:nth-child(1) { animation-delay: 0.1s; }
.info-card:nth-child(2) { animation-delay: 0.2s; }
.info-card:nth-child(3) { animation-delay: 0.3s; }
.image-card { animation-delay: 0.2s; }
.contact-card { animation-delay: 0.3s; }
</style>